/** 智能改造泊位分布 */
import { GetDeviceStatic,GetResourceDeviceStatic } from '@/services/api'
import { useRequest } from 'ahooks'
import { Spin } from 'antd'
import React, { useCallback, useMemo, useState, useEffect ,forwardRef} from 'react'
import Panel from '@/components/Panel/index'
import styles from './style.module.scss'
import ImgSource from '@/assets/img/resource/bowei.png'
import Abutton from '@/components/Abutton'
import ReactEcharts from 'echarts-for-react'
/** 设备管理跳转地址 */
const iframeURL = "http://lz.dgjx0769.com/lz/#/UrbanIntegration/BasicDataManage/DeviceManage";

const ParkingDeviceCount:React.FC<{
 areaCode?: string;
 onDeviceTypeChange:(val:number)=>void;
}> = forwardRef(({areaCode, onDeviceTypeChange},ref) => {
  const { loading, data, error } = useRequest(useCallback(() => {
    return GetResourceDeviceStatic(areaCode )
  },[areaCode]), {
    refreshDeps: [areaCode]
  })

  const AbuttonBox = useMemo(() => {
    return <Abutton iframeURL={iframeURL} text={''} />
  }, [])

  const deviceChange = (val: number) => {
    onDeviceTypeChange(val);
  }

  const getOption = () => {
    if (!data?.data) return {};
    // X轴数据，表示不同类型的泊位
    const xAxisData = ['高位', '地磁', '中位', '社会车场', '自有车场'];
    // 柱状图数据，表示数量
    const countData = [
      data.data.highCount,
      data.data.geoCount,
      data.data.meddleCount,
      data.data.socialGateCount,
      data.data.ownGateCount
    ];
    // 折线图数据，表示收入
    const incomeData = [
      data.data.highIncome,
      data.data.geoIncome,
      data.data.meddleIncome,
      data.data.socialGateIncome,
      data.data.ownGateIncome
    ];
    return {
      tooltip: {
        // 提示框配置，显示在轴上
        trigger: 'axis',
        axisPointer: {
          type: 'shadow' // 使用阴影指示器
        },
        formatter: (params: any) => {
          const [bar, line] = params;
          // 格式化提示信息，显示名称、数量和收入
          return `${bar.name}<br/>数量: ${bar.value}<br/>收入: ${line.value}`;
        }
      },
      grid: {
        left: '3%',
        right: '4%',
        bottom: '3%',
        containLabel: true // 保证标签不被裁剪
      },
      xAxis: {
        type: 'category',
        data: xAxisData,
        axisLine: {
          lineStyle: {
            color: 'rgba(32, 188, 252, 1)' // X轴线颜色
          }
        },
        axisLabel: {
          color: 'rgba(32, 188, 252, 1)', // X轴标签颜色
          interval: 0 // 显示所有标签
        }
      },
      yAxis: [
        {
          type: 'value',
          // name: '数量',
          axisLine: {
            lineStyle: {
              color: 'rgba(32, 188, 252, 1)' // Y轴线颜色
            }
          },
          axisLabel: {
            color: 'rgba(32, 188, 252, 1)' // Y轴标签颜色
          },
          splitLine: {
            lineStyle: {
              color: 'rgba(32, 188, 252, 0.1)' // 网格线颜色
            }
          }
        },
        {
          type: 'value',
          name: '收入',
          axisLine: {
            lineStyle: {
              color: 'rgba(32, 188, 252, 1)' // 第二个Y轴线颜色
            }
          },
          axisLabel: {
            color: 'rgba(32, 188, 252, 1)' // 第二个Y轴标签颜色
          },
          splitLine: {
            show: false // 不显示网格线
          }
        }
      ],
      series: [
        {
          name: '数量',
          type: 'bar',
          data: countData,
          barWidth: '20%',
          itemStyle: {
            color: '#45e2e7', // 柱状图颜色
            borderRadius: [10, 10, 0, 0] // 顶部为半圆形
          }
        },
        {
          // name: '收入',
          type: 'line',
          yAxisIndex: 1,
          data: incomeData,
          symbol: 'circle',
          symbolSize: 15,
          lineStyle: {
            color: '#5470c6', // 折线颜色
            width: 2
          },
          itemStyle: {
            color: '#ffffff', // 折线上的圆点颜色 
            borderColor: '#5470c6',
            borderWidth: 4
          },
          smooth: true // 设置为平滑曲线
        },
        {
          name: 'line',  // 系列名称
          type: 'bar',  // 系列类型为柱状图，叠加到折线图上
          barGap: '-100%',  // 使柱状图与折线图完全重叠
          barWidth: "20%",  // 设置柱状图的宽度
      
          color: '#89e3e9',
          z: -12,  // 设置该系列的层级，使其位于其他系列的下方
          data: incomeData  // 使用之前生成的 lineData 作为数据
        },
        {
          name: 'dotted',  // 系列名称
          type: 'pictorialBar',  // 使用图形柱状图
          symbol: 'rect',  // 设置符号为矩形
          itemStyle: {  // 样式设置
            color: '#0f375f'  // 设置符号颜色为背景色
          },
          symbolRepeat: true,  // 设置符号重复
          symbolSize: [25, 5],  // 设置符号的大小（宽 12，高 4）
          symbolMargin: 1,  // 设置符号之间的间隔
          z: -10,  // 设置该系列的层级，使其位于其他系列的下方
          data: incomeData  // 使用之前生成的 lineData 作为数据
        }
      ]
    };
  };

  const onChartClick = (params: any) => {
    const typeMap: {[key: string]: number} = {
      '高位': 4,
      '地磁': 1,
      '中位': 3,
      '社会车场': 6,
      '自有车场': 5
    };
    deviceChange(typeMap[params.name] || 0);
  };
  
  // 如果有错误，显示错误信息
  if (error && !loading) {
    return (
      <Panel title="智能改造泊位分布">
        <div className="fetch_container" style={{ height: 89 }}>
          请求错误
        </div>
      </Panel>
    );
  }
  
  return (
    <Panel title="智能改造泊位分布">
      {loading || !data?.data ? (
        <div className="fetch_container" style={{ height: 250 }}>
          <Spin />
        </div>
      ) : data?.code === 200 && (
        <div style={{ height: 250 }}>
          <ReactEcharts
            option={getOption()}
            style={{ height: '100%' }}
            onEvents={{
              'click': onChartClick
            }}
          />
        </div>
      )}
    </Panel>
  )
})

export default ParkingDeviceCount